import React from 'react';

const TechnicalRoundRecordingsEmptyState = () => {
	return (
		<div className="bg-white dark:bg-[#1F2A37] rounded-[12px] overflow-hidden">
			<div className="sm:px-4 px-6 py-[14px] text-[#555770] dark:text-[#FFFEE5] text-sm font-light italic">
				No data available
			</div>
		</div>
	);
};

export default TechnicalRoundRecordingsEmptyState;
